__turbopack_context__.v({
  "searchTermContainer": "SearchTermTag-module-scss-module__GVpfXq__searchTermContainer",
});
